
const state = {
  srchVal : 'ddd' , // 아코디언 검색 단어
  srchValTimer : null , 

  tagSearch : {
    val : '' , 
    timer : null , 
    delay : 0 , // 300 
  } , 

  tagList : [] , 
} ; 

const mutations = {} ; 

const actions = {
  setSrchVal ({ state } , val : String ) {
    state.tagSearch.val = val ; 
  } , 
  setTagList ({ state } , list : any ) {
    state.tagList = list ; 
  } , 
  srchInputHandler ({ state , rootState , commit , dispatch } , { crntElement }) {
    let { tagList } = state ; 
    let { val , timer , delay } = state.tagSearch ; 
    let { $wApi , processId , query } = rootState.Comm ; 
    const { category , idx , useTags } = crntElement ; 
    console.log(
      'val : ' ,  val , 
      'category : ' , category , 
      'idx : ' , idx , 
      'useTags : ' , useTags , 
    ) ; 

    const chkSrchStringFunc = async () => {
      clearTimeout( timer ) ; 
      const body = {
        type : query?.type , 
        name : query?.name || undefined , 
      } ; 
      const data = await $wApi.tag.gets( body ) ; 
      const tags = data[ category.toLowerCase() ] ; 
      const useTagsNew : any = [] ; 
      tags.map(( tag : any ) => {
        useTags.map(( useTag : any ) => {
          if ( tag.name.trim() == useTag.name.trim() ) {
            useTagsNew[ useTagsNew.length ] = tag ;  
          }
        }) ; 
      }) ; 
      
      crntElement.tags = tags ; 
      crntElement.useTags = useTagsNew ; 
      dispatch( 'changeTagListView' , {
        idx , 
        viewStatus : useTags.length != 0 ? 'exist-tags' : 'no-tags' , 
      }) ; 
    } ; 

    if ( timer ) clearTimeout( timer ) ; 
    timer = setTimeout( async () => {
      
      const data = await $wApi.tag.gets({
        name : val || undefined , 
        type : category , 
      }) ; 

      if ( val == '' ) {
        chkSrchStringFunc() ; 
        return ; 
      } ; 
      
      // console.log( 'data : ' , data ) ; 
      const tags = data[ category.toLowerCase() ] ; 
      // console.log( 'tags : ', tags ) ; 
      dispatch( 'changeTagListView' , { 
        idx , 
        viewStatus : tags.length != 0 ? 'exist-srch' : 'no-srch' , 
      }) ; 

      // this.changeSrchList({ idx : this.crntIdx , list : tags }) ; 
      dispatch( 'changeSrchList' , { crntElement , list : tags }) ; 
    } , delay ) ; 
  } , 
  changeTagListView ({ state } , { idx , viewStatus }) {
    // console.log({ idx , viewStatus })
    let { tagList } = state ; 

    tagList[ idx ].status.tagListView = null ; 
    setTimeout(() => {
      Object.assign( tagList[ idx ].status , {
        ...tagList[ idx ].status , 
        tagListView : viewStatus , 
      }) ;       
    }) ; 
  } , 

  changeSrchList ({ state } , { crntElement , list }) {
    let { idx } = crntElement ; 
    crntElement.srchList = list ; 

    // console.log( 'list : ' , list ) ; 
    Object.assign( state.tagList[ idx ] , crntElement ) ; 
  } , 
} ; // end of actions 

const getters = {
  srchVal ( state : any ) {
    return state.tagSearch.val ; 
  } , 
  tagList ( state : any ) {
    return state.tagList ; 
  } , 
} ; 

export default {
  namespaced : true , 
  state , 
  mutations , 
  actions , 
  getters 
} ; 